<template>
    <div
    class="activity-bar"
    v-if="barList"
  >
    <div class="one_guild" v-if="barList.length==1">
      <!-- <img src="../../assets/img/activity/1.png" alt=""> -->
      <img @click="jumpLink(barList[0])" :src="barList[0].icon" alt="" />
    </div>
    <div class="bar_wrap" v-else>
      <div class="bar_item" v-for="(guide,item) in barListCur" :key="item" @click="goAct(guide,item)">
        <div class="icon_wrap" :style="{backgroundImage: 'url(' + guide.icon + ')'}">
            <div v-if="guide.bubbleTip" class="bubble_tip">{{guide.bubbleTip}}</div>
          </div>
          <!-- TODO ActiveColor -->
          <div v-if="dataSources == 'bcop'" class="bar_name"
            :style="`color:${ barActive == item ? guide.ActiveColor || '#FF4410' : guide.textColor || '#5B1700'};font-weight:${
              guide.textBold ? 'bold' : 'normal'
            }`"
          >
            {{ guide.text }}
          </div>
          <div v-else class="bar_name" >{{guide.text}}</div>
        </div>
        <div class="bar_item" @click="showMore=true" v-if="barList.length>5">
          <div class="icon_wrap">
            <img class="icon" :src="barList[4].icon" alt="" />
          </div>
          <div class="bar_name">更多</div>
        </div>
    </div>
    <van-action-sheet v-model="showMore">
      <div class="more_bar">
        <div class="all_bar">全部专场</div>
        <div class="more_bar_wrap">
          <div class="more_bar_item" v-for="(guide,index) in barList" :key="index" @click="goAct(guide,index)">
            <div :class="[{'bar_active': barActive == index },'bar_item' ]">
              <div class="bar_name">{{guide.text}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cancle" @click="showMore=false">取消</div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from "vant";
export default {
  name: "ActivityBar",
  components: {
    [ActionSheet.name]: ActionSheet,
  },
  props: {
    dataSources: {
      type: String,
      default: '',
    },
    customGuideList: {
      type: Array,
      default: () => [],
    },
    sensors: {// 埋点对象，必填
      type: Object,
      required: true,
      default:() => {
        return {};
      }
    },
  },
  data() {
    return {
      showMore: false,
      barActive: -1,
    };
  },
  watch:{
    barList: {
      immediate: true,
      handler: function handler(newVal) {
        if(newVal){
          this.sensors.track("WidgetShow", {
            $element_id: "sensor_bcop_guide",
            contentType: "自定义引导",
          });
        }
      }
    },
    showMore: {
      immediate: true,
      handler: function handler(newVal) {
        if(newVal){
          this.sensors.track("$WebClick", {
            $element_id: "sensor_bcop_viewmore",
            contentType: "自定义引导",
          });
        }
      }
    },
  },
  computed: {
    barList(){
      if(this.customGuideList&&this.customGuideList.length>0){
        return this.customGuideList
      }else{
        return null
      }
    },
    barListCur(){
      if(this.barList.length>5){
        return this.barList.slice(0,4)
      }else{
        return this.barList.slice(0,5)
      }
    },
  },
  mounted() {
  },
  methods: {
    goAct(guide,index){
      this.barActive = index
      this.jumpLink(guide)
    },
    jumpLink(guide){
      this.$emit('jumpLink', guide)
    },
    // async activityJumpLink(){
    //   const res = await this.cupid.post(
    //     "/open/noauth/bcop-activity/activityPageInfoQuery",
    //     { pageId: this.sourceIdVal,
    //       isPreview: !!this.$route.query.preview,
    //     }
    //   );
    //   if (res?.code == "0" && res?.data) {
    //     this.barList = res.data.customGuideList
    //     // this.barList = []
    //     this.$emit('getCustomGuideList', this.barList)
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
.activity-bar {
  .one_guild{
    position: fixed;
    bottom: 0;
    width: 100%;
    img{
      width: 100%;
      display: block;
      max-height: 121px;
      .pc & {
        max-width: 375px;
      }
    }
  }
  .bar_wrap{
    display: flex;
    justify-content: space-between;
    padding: 4px 12px 0;
    opacity: 1;
    background: #FFFFFF;
    backdrop-filter: blur(80px);
    // width: 100%;
    left: 0;
    right: 0;
    height: 49px;
    position: fixed;
    // bottom: constant(safe-area-inset-bottom); /* 兼容旧版iOS */
    // bottom: env(safe-area-inset-bottom); /* 适配新版iOS和Android */
    bottom: 0;
    z-index: 999;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    // padding-bottom: 34px;
    box-sizing: content-box;
    margin: 0 auto;
    .pc & {
      width: 375px;
    }
    .bar_item{
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      .icon_wrap{
        position: relative;
        width: 32px;
        height: 24px;
        background-repeat: no-repeat;
        background-size: 100%;
      }
      .icon{
        width: 32px;
        height: 24px;
      }
      .bubble_tip{
        border-radius: 8px;
        opacity: 1;
        background: #FF3838;
        font-size: 9px;
        font-weight: 500;
        line-height: 12px;
        letter-spacing: 0px;
        color: #FFFFFF;
        padding: 2px 4px;
        position: absolute;
        top: -3px;
        left: 19px;
        white-space: nowrap;
      }
      .bar_name{
        font-size: 12px;
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 1px;
      }
    }
  }
  .more_bar{
    padding: 16px 10px 0;
    .all_bar{
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
      letter-spacing: 0px;
      color: #222222;
      margin: 0 0 16px 6px;
    }
    .more_bar_wrap{
      // display: flex;
      // gap:3.5%;
      // flex-wrap: wrap;
      max-height: 50vh;
      overflow-y: auto;
    }
    .more_bar_item{
      width: 33.3%;
      display: inline-block;
    }
    .bar_item{
      border-radius: 21px;
      opacity: 1;
      background: #F2F4F7;
      padding: 12px 10px;
      margin-bottom: 12px;
      margin: 0 6px 12px 6px;
      .bar_name{
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: normal;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0px;
        color: #222222;
        margin: 0 auto;
      }
    }

    .bar_active{
      background: linear-gradient(180deg, #FFB245 1%, #FF4E0E 99%);
      .bar_name{
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0px;
        color: #FFFFFF;
      }
    }
    
  }
  .cancle{
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    border-radius: 22px;
    opacity: 1;
    // background: #F2F4F7;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0px;
    color: #222222;
    margin: 18px 16px 44px;
    box-sizing: border-box;
    border: 1px solid #EDEFF2;
  }

}
// 底部bar样式
.activity-bar {
  .van-popup{
    top: auto !important;
  }
  .van-popup--bottom{
    width: 100% !important;
    .pc & {
      width: 375px !important;
    }
  }
}
</style>
